<div class="layout">
  <app-toolbar class="w-100-percent pt-8 pb-8"></app-toolbar>
  <div [ngClass]="[isEnterprise ? 'divider': 'divider']" ></div>
  <mat-sidenav-container class="flex-auto">
    <mat-sidenav class="right-sidenav" #rightSidenav
                 [autoFocus]="false"
                 [(opened)]="sidenavService.rightExpanded"
                 (closed)="sidenavService.resetAfterClosed()" position="end">
    <ng-container #container></ng-container>
    </mat-sidenav>
    <mat-sidenav-content (scroll)="scroll($event)" #scrollableContainer class="flex-col items-center content-wrapper">
      <div class="content">
        <app-faq-support-buttons *ngIf="!authService?.hideToolbar" class="fixed-icon"></app-faq-support-buttons>
        <router-outlet></router-outlet>
      </div>

      <div class="scroll-fixed-wrapper">
        <div class="scroll-to-bottom">
          <mat-icon [svgIcon]="scrollToBottom? 'arrow_upward' : 'arrow_downward'" class="make-center icon h-32 w-32" (click)="windowScroll()"></mat-icon>
        </div>
      </div>

      <app-footer class="footer"></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>